import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgressBar() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 180,
        damping: 30,
        restDelta: 0.001,
    });

    return (
        <motion.div
            data-testid="scroll-progress-bar"
            aria-hidden="true"
            style={{ scaleX }}
            className="fixed left-0 top-0 z-[100] h-[3px] w-full origin-left bg-brand-orange shadow-[0_0_12px_rgba(232,135,60,0.5)]"
        />
    );
}
